import { Component, OnInit } from '@angular/core';
import { ToastPackage } from 'ngx-toastr';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-accessible-toast',
  templateUrl: './accessible-toast.component.html',
  styleUrls: ['./accessible-toast.component.scss'],
  animations: [
    trigger('flyInOut', [
      state('visible', style({ opacity: 1 })),
      transition('void => visible', [
        style({ opacity: 0 }),
        animate('400ms ease-out')
      ]),
      transition('visible => void', [
        animate('400ms ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class AccessibleToastComponent implements OnInit {

  id = 'toast-desc-' + Math.random().toString(36).substring(2, 9);

  constructor(public toastPackage: ToastPackage) {}

  ngOnInit() {
    if (this.toastPackage.config.timeOut > 0 && this.toastPackage.toastRef) {
      setTimeout(() => this.toastPackage.toastRef.close(), this.toastPackage.config.timeOut);
    }
  }

  get title(): string {
    return this.toastPackage.title;
  }

  get message(): string {
    return this.toastPackage.message;
  }

  get iconClass(): string {
    switch (this.toastPackage.toastType) {
      case 'error': return 'mdi-alert-circle';
      case 'success': return 'mdi-check-circle';
      case 'info': return 'mdi-information';
      case 'warning': return 'mdi-alert';
      default: return 'mdi-information';
    }
  }

  get tooltip(): string {
    return this.toastPackage.title || 'Notification';
  }
}